import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Calendar, Clock, MapPin, User, Target, Tag } from "lucide-react";
import { api, mediaUrl } from "../lib/api";
import { Container, StatusBadge, Empty } from "../components/site/Common";
import { dateRange, timeRange } from "../components/site/Cards";
import { Lightbox } from "../components/site/Lightbox";

export default function EventDetail() {
  const { id } = useParams();
  const [e, setE] = useState(undefined);
  const [idx, setIdx] = useState(null);
  useEffect(() => { api.get(`/content/events/${id}`).then((r) => setE(r.data)).catch(() => setE(null)); }, [id]);
  if (e === undefined) return <div className="min-h-screen pt-36"><Container><div className="h-64 rounded-2xl bg-slate-200 animate-pulse" /></Container></div>;
  if (!e) return <div className="min-h-screen pt-36"><Container><Empty>Event not found. <Link to="/events" className="text-blue-700 font-semibold">Back to events</Link></Empty></Container></div>;
  const photos = (e.photos || []).map((u) => ({ url: u, media_type: "photo", title: e.title }));
  const meta = [[Tag, "Type", e.type], [Calendar, "Date", dateRange(e)], [Clock, "Time", timeRange(e) || "To be announced"], [MapPin, "Venue", e.venue || "To be announced"], [User, "Trainer / Organizer", e.organizer || "To be announced"], [Target, "Age category / Level", e.level || "To be announced"]];
  return (
    <section className="pt-32 pb-20 bg-slate-50 min-h-screen" data-testid="event-detail">
      <Container>
        <Link to="/events" className="inline-flex items-center gap-2 text-sm font-semibold text-slate-600 hover:text-blue-700 mb-8" data-testid="event-back-link"><ArrowLeft className="h-4 w-4" /> All events</Link>
        <div className="grid gap-10 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <StatusBadge status={e.status} />
            <h1 className="mt-4 font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-[#0B1F44]" data-testid="event-detail-title">{e.title}</h1>
            {e.image && <img src={mediaUrl(e.image)} alt={e.title} className="mt-8 w-full aspect-[16/9] object-cover rounded-2xl" />}
            <p className="mt-8 text-slate-700 leading-relaxed whitespace-pre-line">{e.description}</p>
            {photos.length > 0 && (
              <div className="mt-10">
                <h2 className="font-display text-xl font-bold text-[#0B1F44] mb-4">Event photographs</h2>
                <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                  {photos.map((p, i) => <button key={i} onClick={() => setIdx(i)} className="aspect-square overflow-hidden rounded-xl" data-testid={`event-photo-${i}`}><img src={mediaUrl(p.url)} alt="" className="h-full w-full object-cover hover:scale-105 transition-transform" /></button>)}
                </div>
              </div>
            )}
          </div>
          <aside className="card p-7 h-fit space-y-5 lg:sticky lg:top-28">
            {meta.map(([Icon, l, v]) => (
              <div key={l} className="flex gap-3"><Icon className="h-5 w-5 text-blue-600 mt-0.5 shrink-0" /><div><p className="text-xs text-slate-500">{l}</p><p className="font-medium text-[#0B1F44]">{v}</p></div></div>
            ))}
            <Link to="/contact" className="btn-primary w-full justify-center" data-testid="event-contact-btn">Enquire with TDBA</Link>
          </aside>
        </div>
      </Container>
      <Lightbox items={photos} index={idx} onClose={() => setIdx(null)} onIndex={setIdx} />
    </section>
  );
}
